import React, { FC } from 'react';

import { useFeatureFlags, useUpdateFeatureFlags } from '@portals/api/partners';
import Modals from '@portals/framework/modals';
import { PartnerFeatureFlagsType } from '@portals/types';

import { FEATURE_LIST } from './constants';

interface FeatureFlagsProps {
  closeMe: () => void;
}

const FeatureFlags: FC<FeatureFlagsProps> = ({ closeMe }) => {
  const updateFeatureFlags = useUpdateFeatureFlags();
  const features = useFeatureFlags();

  const onSubmit = async (
    updatedFeatures: Partial<PartnerFeatureFlagsType>
  ) => {
    try {
      await updateFeatureFlags.mutateAsync({ feature_flags: updatedFeatures });

      closeMe();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modals.FeatureFlagsModal<PartnerFeatureFlagsType>
      closeMe={closeMe}
      features={features}
      featuresToDisplay={FEATURE_LIST}
      onSubmit={(featureFlags) => onSubmit(featureFlags)}
    />
  );
};

export default FeatureFlags;
